import { AnchorHTMLAttributes } from "react";
import { NextLink } from "../../Links";
import { BaseButtonProps } from "../Button";
import { buttonVariants } from "../buttonVariants";
import { cn } from "../../../utils/cn";

export interface LinkButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    BaseButtonProps {
  disabled?: boolean;
  "data-testid"?: string;
}

export function LinkButton({
  className,
  vSize,
  vColor,
  vStyle,
  children,
  disabled,
  "data-testid": dataTestId,
  ...props
}: LinkButtonProps) {
  const css = cn(
    buttonVariants({ vColor, vStyle, vSize }),
    vSize === "sm" && "ring-1",
    disabled &&
      "cursor-not-allowed bg-gray-400 hover:bg-gray-400 select-none pointer-events-none",
    className,
  );
  // if (disabled) {
  //   css += " pointer-events-none";
  // }

  // Auto-generate data-testid from children or href if not provided
  const generateTestId = () => {
    if (typeof children === "string" && children) {
      const sanitized = children
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
      return sanitized ? `link-button-${sanitized}` : "link-button";
    }
    if (props.href && typeof props.href === "string") {
      const sanitized = props.href
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "-")
        .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
      return sanitized ? `link-button-${sanitized}` : "link-button";
    }
    return "link-button";
  };

  const testId = dataTestId || generateTestId();

  if (disabled) {
    return (
      <div role="link" aria-disabled className={css} data-testid={testId}>
        {children}
      </div>
    );
  }
  return (
    <NextLink className={css} data-testid={testId} {...props}>
      {children}
    </NextLink>
  );
}
